<template>
  <div class="flex width-100">
    <div class="width-100">
      <h2>Advanced Reporting</h2>

      <GridContainer
        form-container
        class="align-left"
      >
      <el-select v-model="profile" value-key="" placeholder="Select a Profile" filterable>
        <el-option v-for="item in options"
          :key="item.value"
          :label="item.organization.name"
          :value="item.id">
          <span>{{ item.organization.name }} | ID: {{item.id}} | {{item.status}} || Users: {{item.users.length}}</span>
        </el-option>
      </el-select>
      <el-select v-model="profile" value-key="" placeholder="Select a Position" filterable disabled>
        <el-option v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </GridContainer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvReport',
  data() {
    return {
      profile: null,
    }
  },
  computed: {
    options() {
      return this.$store.getters.profilesData
    }
  },
  async created() {
    await this.getProfiles()
  },
  methods: {
    getProfiles() {
      this.$store.dispatch('getProfiles')
    }
  }
}
</script>

<style>

</style>
